import React, { useState } from 'react';
import './CategoryManager.css';

export const CategoryManager = ({
  categories,
  allDecks,
  deckCategoryMap,
  onAddCategory,
  onDeleteCategory,
  onRenameCategory,
  onAssignDeck,
  getCategorizedDecks,
  onClose
}) => {
  const [newCategoryName, setNewCategoryName] = useState('');
  const [editingCategory, setEditingCategory] = useState(null);
  const [editName, setEditName] = useState('');
  const [selectedDeck, setSelectedDeck] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');

  const categorizedDecks = getCategorizedDecks(Object.keys(allDecks));

  const handleAddCategory = () => {
    if (newCategoryName.trim()) {
      const success = onAddCategory(newCategoryName.trim());
      if (success) {
        setNewCategoryName('');
      }
    }
  };

  const handleRenameCategory = (oldName) => {
    if (editName.trim() && editName !== oldName) {
      const success = onRenameCategory(oldName, editName.trim());
      if (success) {
        setEditingCategory(null);
        setEditName('');
      }
    } else {
      setEditingCategory(null);
      setEditName('');
    }
  };

  const handleAssignDeck = () => {
    if (selectedDeck && selectedCategory) {
      onAssignDeck(selectedDeck, selectedCategory);
      setSelectedDeck('');
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="category-manager" onClick={(e) => e.stopPropagation()}>
        <div className="category-manager-header">
          <h2>Manage Categories</h2>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>

        <div className="category-manager-content">
          {/* Add New Category */}
          <div className="category-section">
            <h3>Add New Category</h3>
            <div className="category-input-group">
              <input
                type="text"
                className="category-input"
                placeholder="Category name..."
                value={newCategoryName}
                onChange={(e) => setNewCategoryName(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && handleAddCategory()}
              />
              <button
                className="category-add-btn"
                onClick={handleAddCategory}
                disabled={!newCategoryName.trim()}
              >
                Add Category
              </button>
            </div>
          </div>

          {/* Assign Deck to Category */}
          <div className="category-section">
            <h3>Assign Deck to Category</h3>
            <div className="category-assign-group">
              <select
                className="category-select"
                value={selectedDeck}
                onChange={(e) => setSelectedDeck(e.target.value)}
              >
                <option value="">Select a deck...</option>
                {Object.keys(allDecks).map(deckName => (
                  <option key={deckName} value={deckName}>
                    {deckName} ({deckCategoryMap[deckName] || 'Uncategorized'})
                  </option>
                ))}
              </select>
              <select
                className="category-select"
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e.target.value)}
              >
                <option value="">Select a category...</option>
                {Object.keys(categories).map(catName => (
                  <option key={catName} value={catName}>
                    {catName}
                  </option>
                ))}
              </select>
              <button
                className="category-assign-btn"
                onClick={handleAssignDeck}
                disabled={!selectedDeck || !selectedCategory}
              >
                Assign
              </button>
            </div>
          </div>

          {/* Categories List */}
          <div className="category-section">
            <h3>Categories ({Object.keys(categories).length})</h3>
            <div className="categories-list">
              {Object.keys(categories).map(catName => (
                <div key={catName} className="category-item">
                  {editingCategory === catName ? (
                    <input
                      type="text"
                      className="category-edit-input"
                      value={editName}
                      onChange={(e) => setEditName(e.target.value)}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') handleRenameCategory(catName);
                        if (e.key === 'Escape') {
                          setEditingCategory(null);
                          setEditName('');
                        }
                      }}
                      onBlur={() => handleRenameCategory(catName)}
                      autoFocus
                    />
                  ) : (
                    <>
                      <div className="category-item-info">
                        <span className="category-name">📁 {catName}</span>
                        <span className="category-count">
                          {categorizedDecks[catName]?.length || 0} decks
                        </span>
                      </div>
                      <div className="category-actions">
                        {catName !== 'Uncategorized' && (
                          <>
                            <button
                              className="category-action-btn"
                              onClick={() => {
                                setEditingCategory(catName);
                                setEditName(catName);
                              }}
                            >
                              ✏️
                            </button>
                            <button
                              className="category-action-btn category-delete"
                              onClick={() => {
                                if (window.confirm(`Delete category "${catName}"? Decks will be moved to Uncategorized.`)) {
                                  onDeleteCategory(catName);
                                }
                              }}
                            >
                              🗑️
                            </button>
                          </>
                        )}
                      </div>
                    </>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Categorized Decks View */}
          <div className="category-section">
            <h3>Decks by Category</h3>
            <div className="categorized-decks">
              {Object.entries(categorizedDecks).map(([catName, decks]) => (
                decks.length > 0 && (
                  <div key={catName} className="categorized-group">
                    <div className="categorized-group-header">
                      📁 {catName} ({decks.length})
                    </div>
                    <div className="categorized-group-decks">
                      {decks.map(deckName => (
                        <div key={deckName} className="categorized-deck-item">
                          {deckName}
                        </div>
                      ))}
                    </div>
                  </div>
                )
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
